import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

import { requestSalesSettingsAsync } from '@/modules/AdminTools/redux/planBuilder/can-edit-settings/sales-settings';

const Wrapper = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestSalesSettingsAsync.request());
  }, [dispatch]);

  return (
    <div className="m-6">
      <Outlet />
    </div>
  );
};

export default Wrapper;
